import { RootState } from "@/app/stores"
import { getDashboardCards, getDashboardTransactions, IDashboardCard, IDashboardTransactionsResponse } from "@/shared/api/onboarding"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchBusinessCard = createAsyncThunk<
    IDashboardCard,
    string,
    { state: RootState }
>('businessCardDetails/fetchBusinessCard', async (cardId, thunkAPI) => {
    try {
        const response = await getDashboardCards()
        const card = response.data.find(c => c.id === cardId)
        if (!card) {
            throw new Error('Card not found')
        }
        return card
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message || 'Card not found',
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchBusinessCardTransactions = createAsyncThunk<
    IDashboardTransactionsResponse,
    { cardId: string; page?: number; limit?: number },
    { state: RootState }
>('businessCardDetails/fetchBusinessCardTransactions', async ({ cardId, page = 1, limit = 20 }, thunkAPI) => {
    try {
        const response = await getDashboardTransactions({
            card_id: cardId,
            page,
            limit
        })

        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

